import Scene from 'scenejs';
import _ from 'lodash';
import EventBus from '@/EventBus';
import MediaScene from '@scenejs/media';
import {
  fade,
  panbottom,
  panleft,
  panright,
  pantop, photoRiseBottom, photoRiseLeft, photoRiseRight, photoRiseTop,
  photoZomEnterIn, photoZomEnterOut,
  stomp,
  typewriter,
  burst,
  zoomin,
  zoomout,
  transitionFade,
  transitionPanLeft,
  transitionPanRight,
  transitionPanTop,
  transitionPanBottom,
  transitionNone,
  singlePageDisplay,
  lastPageDisplay,
} from '../library/Animations';

const CanvasPanelMixin = {
  data() {
    return {
      sceneO:         null,
      page:           null,
      played:         0.0,
      isFullscreen:   false,
      allAudioScenes: [],
      modules:        {
        typewriter,
        burst,
        panleft,
        panright,
        pantop,
        panbottom,
        zoomin,
        zoomout,
        stomp,
        fade,
        photoZomEnterIn,
        photoZomEnterOut,
        photoRiseTop,
        photoRiseBottom,
        photoRiseLeft,
        photoRiseRight,
        transitionFade,
        transitionPanLeft,
        transitionPanRight,
        transitionPanTop,
        transitionPanBottom,
        transitionNone,
        singlePageDisplay,
        lastPageDisplay,
      },
    };
  },

  computed: {
    hasProductAudio() {
      return this.product && this.product.audioDetails && this.product.audioDetails.audioUrl;
    },
  },

  methods: {
    stopVideo() {
      this.sceneO && this.sceneO.end() && this.sceneO.setTime(0);
      clearInterval(this.interval);
      this.$store.commit('activeProduct/setIsAnimationInProgress', false);
    },
    playVideo(transition = {}, videoScrubbingMode = false) {
      if (videoScrubbingMode) {
      EventBus.$emit('showHideLoader', true);
      }
      if (!this.$store.getters['activeProduct/getShowVideoPanel']) {
        this.$store.commit('activeProduct/updateShowVideoPanel', true);
      }
      this.moveProgressBar();
      this.playAnimation(!_.isEmpty(transition), transition, videoScrubbingMode);
      _.isEmpty(transition) && !videoScrubbingMode && this.$store.commit('activeProduct/setIsAnimationInProgress', true);
    },
    playAnimation(transitionOnly = false, transition = {}, videoScrubbingMode) { // transitionOnly is for transition preview upon selecetion
      const self          = this;
      let start           = 0.0;
      let pageStyle       = null;
      this.sceneO         = new Scene();
      self.allAudioScenes = [];
      let selectorClass   = '';
      let selectorId      = '';
      this.product.pages.forEach((page, i) => {
        page.animation.startTime = start;
        pageStyle                = page.animation.style;
        let scale                = document.querySelector(`#main_page_div${i}`).style.transform;
        scale                    = parseFloat(scale.match(/-?\d+\.?\d*/)[0]);
        selectorClass            = '#main_page_div';
        selectorId               = '#main_page_div';
        if (page.animation.style.includes('pageZoom')) {
          selectorClass = '.page-id-';
          selectorId    = '#page-id-';
          scale         = '-50%, 0px';
        }
        if (page.objectList.length) {
          page.objectList.forEach((object) => {
            const clonedObj = _.cloneDeep(object);
            if (object.animation && object.animation.style && object.animation.style !== '') {
              const style     = object.animation.style;
              const animation = { ...object.animation };
              console.log(animation);
              let selector = `.canvas-section .page-id-${i} div[data-elementindex='${object.elementIndex}']`;
              if (style.includes('photo')) {
                selector += ' img';
              }
              animation.selector                     = selector;
              clonedObj.animation.selector           = selector;
              clonedObj.animation.startTime          = start;
              clonedObj.animation.duration           = page.animation.duration;
              clonedObj.animation.parentPageDuration = page.animation.duration;
              clonedObj.objectOpacity                = clonedObj.effects ? clonedObj.effects.transparency.value / 100 : 1;
              if (clonedObj.type === 'shape') { clonedObj.objectOpacity = clonedObj.Alpha / 100; }
              const sceneItem = this.modules[style](clonedObj);
              self.sceneO.setItem(selector, sceneItem);
            }
            if (object.type == 'video') {
              clonedObj.animation.parentPageDuration = page.animation.duration;
              if (clonedObj.videoDetails.audio) {
                const audioScene = self.getAudioScene(clonedObj, start, i);
                const identifier = `audio${clonedObj.Id}${i}`;
                self.sceneO.setItem(identifier, audioScene);
                self.allAudioScenes.push(identifier);
              }
              const videoScene = self.getVideoScene(clonedObj, start, i);
              self.sceneO.setItem(`video${clonedObj.Id}${i}`, videoScene);
            }
          });
        }
        start += parseFloat(page.animation.duration);
      });
      if (this.product.transitions && this.product.transitions.length > 0) {
        this.product.transitions.forEach((tr, i) => {
          const scene = this.modules[tr.name](tr, i);
          self.sceneO.setItem(`transition${i}`, scene);
          if (i + 1 == this.product.transitions.length) {
            const sceneEnd = this.modules.lastPageDisplay(tr, i);
            self.sceneO.setItem('page-last', sceneEnd);
          }
        });
      } else {
        const sceneSingle = this.modules.singlePageDisplay(this.product.pages[0].animation);
        self.sceneO.setItem('page-single', sceneSingle);
      }
      self.sceneO.on('animate', (e) => {
        self.played = e.time;
        if (self.sceneO.isEnded()) {
          this.$store.commit('activeProduct/setIsAnimationInProgress', false);
          this.$store.commit('activeProduct/updateShowVideoPanel', false);
        }
        self.muteUnusedVideos();
        if (this.hasProductAudio) {
          self.fadeProductAudio();
        }
      });
      self.sceneO.on('play', () => {
        if (this.hasProductAudio) {
          this.syncProductAudio();
          this.$refs.canvasaudio.play();
        }
        if (transitionOnly) {
          const previewDuration = (transition[0].firstScreenDuration || transition[0].secondScreenDuration) < 2 ? 2000 : 4000;
          setTimeout(() => {
            console.log(self.$store.getters['activeProduct/getIsAnimationInProgress']);
            if (!self.$store.getters['activeProduct/getIsAnimationInProgress']) {
              self.sceneO.finish();
            }
          }, previewDuration);
        }
      });
      self.sceneO.on('paused', () => {
        if (this.hasProductAudio) {
          this.$refs.canvasaudio.pause();
        }
      });

      if (transitionOnly) {
        const setTime         = (transition[0].firstScreenDuration || transition[0].secondScreenDuration) < 2 ? 0.5 : 2;
        self.sceneO.setTime(transition[0].secondScreenStartTime - setTime);

      }
      self.checkVideosLoaded().then(() => {
        setTimeout(() => {
          EventBus.$emit('showHideLoader', false);
          if (videoScrubbingMode) {
            self.sceneO.play().pause();
          } else {
          self.sceneO.play();
          }
        }, 1);
      }).catch((error) => {
        console.error('Error while checking for video loading:', error);
      });
    },

    checkVideosLoaded() {
      return new Promise((resolve) => {
        const videos = Array.from(document.querySelectorAll('.canvas-video-wrapper .page-0 video'));
        function checkAllVideosLoaded() {
          return videos.every(video => video.readyState >= 3);
        }
        function checkRepeatedly() {
          if (checkAllVideosLoaded()) {
            resolve('All videos have been loaded.');
          } else {
            setTimeout(checkRepeatedly, 100); // Check again after 100 milliseconds
          }
        }
        checkRepeatedly(); // Start the initial check
      });
    },

    syncProductAudio() {
      const { startTime }                = this.product.audioDetails;
      this.$refs.canvasaudio.currentTime = parseFloat(startTime + this.currentTime());
      // this.$refs.canvasaudio.volume      = 0;
    },

    fadeProductAudio() {
      console.log(this.product.audioDetails);
      const {
        startTime, endTime, fadeIn, fadeOut,
      } = this.product.audioDetails;
      console.log('startTime: ', startTime);
      console.log('endTime: ', endTime);
      console.log('fadeIn: ', fadeIn);
      console.log('fadeOut: ', fadeOut);

      if ((parseFloat(this.$refs.canvasaudio.currentTime)) >= endTime) {
        this.$refs.canvasaudio.volume = 0;
        console.log('(startTime + parseFloat(this.currentTime())) > endTime');
        return;
      }

      if ((parseFloat(this.$refs.canvasaudio.currentTime)) < (fadeIn + startTime)) {
        const volume = this.calculatePercentage(
          parseFloat(startTime),
          parseFloat(fadeIn + startTime),
          parseFloat(this.$refs.canvasaudio.currentTime),
        ) / 100;
        console.log(volume);
        this.$refs.canvasaudio.volume = volume;
      } else if ((parseFloat(this.$refs.canvasaudio.currentTime)) > (fadeOut)) {
        let volume = this.calculatePercentage(
          parseFloat(fadeOut),
          parseFloat(endTime),
          parseFloat(this.$refs.canvasaudio.currentTime),
        ) / 100;
        console.log('currentTime: ', this.$refs.canvasaudio.currentTime);
        console.log(volume);
        if (volume < 0) {
          // volume = 0;
        } else if (volume > 1) {
          volume = 1;
        } else {
          volume = 1 - volume;
          // volume = 1 % volume;
        }
        console.log('volume ', volume);
        this.$refs.canvasaudio.volume = volume;
      } else {
        this.$refs.canvasaudio.volume = 1;
      }
    },

    calculatePercentage(startRange, endRange, currentValue) {
      if (currentValue < startRange) {
        return 0;
      }
      if (currentValue > endRange) {
        return 100;
      }
      const range           = endRange - startRange;
      const normalizedValue = currentValue - startRange;
      const percentage      = (normalizedValue / range) * 100;
      return percentage;
    },

    getAudioScene(object, startTime, pageIndex) {
      const mediaScene         = new MediaScene();
      let audioPlayingDuration = object.animation.parentPageDuration;
      if (object.videoDetails.endTime) {
        audioPlayingDuration = object.videoDetails.endTime - object.videoDetails.startTime;
        if (audioPlayingDuration > object.animation.parentPageDuration) {
          audioPlayingDuration =  object.animation.parentPageDuration;
        }
      }
      mediaScene
        .addMedia(object.videoDetails.audio)
        .seek(parseFloat(object.videoDetails.startTime), parseFloat(object.videoDetails.startTime) + parseFloat(audioPlayingDuration))
        .setVolume(1)
        .setPlaySpeed(1)
        .setDelay(startTime)
        .setIterationCount(object.animation.parentPageDuration / audioPlayingDuration);

      mediaScene.startTime = startTime;
      mediaScene.endTime   = object.animation.parentPageDuration;

      return mediaScene;
    },

    getVideoScene(object, startTime, pageIndex) {
      const video              = document.querySelector(`.canvas-animation-page.page-id-${pageIndex} #video${object.Id}`);
      const mediaScene         = new MediaScene();
      let audioPlayingDuration = object.animation.parentPageDuration;
      if (object.videoDetails.endTime) {
        audioPlayingDuration = object.videoDetails.endTime - object.videoDetails.startTime;
        if (audioPlayingDuration > object.animation.parentPageDuration) {
          audioPlayingDuration =  object.animation.parentPageDuration;
        }
      }
      mediaScene
        .addMedia(video)
        .seek(parseFloat(object.videoDetails.startTime), parseFloat(object.videoDetails.startTime) + parseFloat(audioPlayingDuration))
        .setVolume(1)
        .setPlaySpeed(1)
        .setDelay(startTime)
        .setIterationCount(object.animation.parentPageDuration / audioPlayingDuration);

      return mediaScene;
    },

    muteUnusedVideos() {
      if (this.allAudioScenes.length) {
        this.allAudioScenes.forEach((audSceneName) => {
          const audScene    = this.sceneO.getItem(audSceneName);
          const currentTime = parseFloat(this.currentTime());
          if (currentTime > (parseFloat(audScene.endTime) + parseFloat(audScene.startTime))) {
            audScene.pause();
            this.sceneO.setItem(audSceneName, audScene);
          }
        });
      }
    },

    currentTime() {
      return this.sceneO
        ? this.sceneO.getTime() < 10
          ? `0${this.sceneO.getTime().toFixed(1)}`
          : this.sceneO.getTime().toFixed(1)
        : '00.00';
    },
  },
};

export default CanvasPanelMixin;
